import { createSelector } from 'react-sweet-state';

import type { FieldId } from '../../../../common/types/form/form-fields';
import type { FormRendererState } from '../../types';
import { fieldCustomErrorSelector } from '../field-custom-error';
import { fieldValidationErrorsSelector } from '../field-validation-errors';

export interface FieldInvalidSelectorProps {
	fieldId: FieldId;
}

/**
 * This selector has been updated to return if the field has validation or custom errors.
 */
export const fieldInvalidSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	FieldInvalidSelectorProps,
	boolean
> = createSelector(
	(state: FormRendererState) => state,
	(_, props: FieldInvalidSelectorProps) => props.fieldId,
	fieldCustomErrorSelector,
	fieldValidationErrorsSelector,
	(_, __, customError, validationErrors) =>
		customError !== undefined || validationErrors.length > 0,
);
